import React, { useState, useEffect } from 'react';
import Header from './Header';
import { Link } from 'react-router-dom';
import { getLatestActiveAnnouncement } from '../data/announcements';
import { useAuth } from '../contexts/AuthContext';
import WhatsNewModal from './WhatsNewModal';

function Layout({ children }) {
  const { user } = useAuth();
  const [showAnnouncement, setShowAnnouncement] = useState(false);
  const [latestAnnouncement, setLatestAnnouncement] = useState(null);
  useEffect(() => {
    const checkAnnouncements = () => {
      if (!user) return;
      const latest = getLatestActiveAnnouncement();
      if (latest && latest.active) {
        const lastSeenId = localStorage.getItem('last_seen_announcement_id');
        if (String(lastSeenId) !== String(latest.id)) {
          setLatestAnnouncement(latest);
          setShowAnnouncement(true);
        }
      }
    };
    checkAnnouncements();
  }, [user]);
  const handleCloseModal = () => {
    if (latestAnnouncement) {
      localStorage.setItem('last_seen_announcement_id', latestAnnouncement.id);
    }
    setShowAnnouncement(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>
      <footer className="border-t border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-sm text-gray-500">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-2">
            <div>
              © {new Date().getFullYear()} - Vihaan Herbals - All rights reserved
            </div>
            <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
              <Link 
                to="/terms-and-conditions" 
                className="text-gray-600 hover:text-gray-900 underline"
              >
                Terms and Conditions
              </Link>
              <span className="text-gray-400">|</span>
              <Link 
                to="/privacy-policy" 
                className="text-gray-600 hover:text-gray-900 underline"
              >
                Privacy Policy
              </Link>
              <span className="text-gray-400">|</span>
              <Link 
                to="/no-refund-policy" 
                className="text-gray-600 hover:text-gray-900 underline"
              >
                Return and Refund Policy
              </Link>
              <span className="text-gray-400">|</span>
              <Link 
                to="/about" 
                className="text-gray-600 hover:text-gray-900 underline"
              >
                About Us
              </Link>
              <span className="text-gray-400">|</span>
              <Link 
                to="/contact" 
                className="text-gray-600 hover:text-gray-900 underline"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </footer>

      {showAnnouncement && latestAnnouncement && (
        <WhatsNewModal
          title={latestAnnouncement.title}
          content={latestAnnouncement.content}
          version={latestAnnouncement.version}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
}

export default Layout;


